import { render, staticRenderFns } from "./system.vue?vue&type=template&id=3a31ba9c&scoped=true"
import script from "./system.vue?vue&type=script&lang=ts"
export * from "./system.vue?vue&type=script&lang=ts"
import style0 from "./system.vue?vue&type=style&index=0&id=3a31ba9c&prod&lang=scss&scoped=true"
import style1 from "./system.vue?vue&type=style&index=1&id=3a31ba9c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a31ba9c",
  null
  
)

export default component.exports